module.exports = __webpack_public_path__ + "static/media/Bell.37dcd414.svg";